/* eslint-disable react/no-unknown-property */
import PropTypes from 'prop-types';

const OtherCityImage = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="203"
    height="154"
    viewBox="0 0 203 154"
    className={className}
  >
    <defs>
      <linearGradient
        id="a"
        x1="49.991%"
        x2="49.991%"
        y1="100.006%"
        y2="-.007%"
      >
        <stop offset="0%" stopColor="gray" stopOpacity=".25" />
        <stop offset="54%" stopColor="gray" stopOpacity=".12" />
        <stop offset="100%" stopColor="gray" stopOpacity=".1" />
      </linearGradient>
      <linearGradient id="b" x1=".002%" x2="100.029%" y1="49.995%" y2="49.995%">
        <stop offset="0%" stopColor="gray" stopOpacity=".25" />
        <stop offset="54%" stopColor="gray" stopOpacity=".12" />
        <stop offset="100%" stopColor="gray" stopOpacity=".1" />
      </linearGradient>
      <linearGradient id="c" x1="0%" y1="50%" y2="50%">
        <stop offset="0%" stopColor="gray" stopOpacity=".25" />
        <stop offset="54%" stopColor="gray" stopOpacity=".12" />
        <stop offset="100%" stopColor="gray" stopOpacity=".1" />
      </linearGradient>
      <linearGradient id="d" x1="0%" y1="50.5%" y2="50.5%">
        <stop offset="0%" stopColor="gray" stopOpacity=".25" />
        <stop offset="54%" stopColor="gray" stopOpacity=".12" />
        <stop offset="100%" stopColor="gray" stopOpacity=".1" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <ellipse
        cx="101"
        cy="148.5"
        fill="#32B496"
        fillRule="nonzero"
        opacity=".1"
        rx="77"
        ry="5.5"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M200.629 122.88a15.337 15.337 0 0 1-3.063 3.447c-.327.27-.666.533-1.01.779-4.414 3.172-10.322 4.567-16.062 5.47-11.144 1.754-22.521 2.095-33.85 2.43-9.538.284-19.082.568-28.624.757-13.638.274-27.278.356-40.895 0a556.308 556.308 0 0 1-22.313-1.035c-13.79-.944-27.935-2.613-39.939-8.438a41.185 41.185 0 0 1-6.272-3.717c-3.26-2.378-5.945-5.255-7.38-8.663-2.31-5.477-1.09-11.632 1.549-17.003 1.599-3.247 3.676-6.288 5.83-9.303 1.276-1.789 2.58-3.567 3.82-5.372.13-.178.256-.368.38-.553a64.265 64.265 0 0 0 3.452-5.69 52.354 52.354 0 0 0 2.283-4.842 42.243 42.243 0 0 0 1.599-4.623c.295-1.059.543-2.12.735-3.182 1.05-5.782.496-11.56-2.613-16.79l-.094-.158-.04-.062c-.877-1.442-1.936-2.801-2.977-4.165-1.243-1.636-2.467-3.283-3.329-5.085-2.267-4.76-1.776-10.113-.952-15.198 1.1-6.757 3.146-14.049 9.483-18.262C26.929-.763 36.273-.54 44.444 1.028c12.695 2.43 24.418 7.53 36.255 12.13 11.837 4.6 24.23 8.808 37.245 9.258 11.492.4 24.896-2.587 32.523-10.359 7.408-7.546 21.334-8.12 31.375-3.557 9.58 4.348 15.774 13.553 15.308 22.744-.678 13.386-13.565 23.652-21.254 35.365a37.75 37.75 0 0 0-1 1.6c-3.02 5.11-4.88 10.977-2.652 16.296 2.988 7.126 11.86 10.602 19.342 15.079 3.614 2.16 6.911 4.556 9.043 7.714.08.114.153.226.226.338 3.007 4.66 2.78 10.61-.226 15.244z"
        opacity=".1"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M13.911 80.793c.974-1.5 1.896-3.049 2.741-4.628a52.43 52.43 0 0 0 2.284-4.842 42.315 42.315 0 0 0 1.599-4.628 35.21 35.21 0 0 0 .735-3.184c1.05-5.787.496-11.57-2.613-16.806-.03-.051-.062-.107-.094-.158l-3.02-4.231h22.408v14.91h6.233v44.723h8.042V87.442h9.65v14.507h8.038V77.166h.402V64.27h7.637v12.895h17.693v19.342h9.853v-6.053h6.04v6.053h9.85V39.286h12.867v-9.068h2.212v9.068h3.618v17.932h6.435v-14.91h5.428V27h11.258v15.308h5.43v14.91h6.634v11.163c-3.02 5.114-4.879 10.986-2.652 16.31 2.988 7.133 11.858 10.613 19.34 15.094 3.613 2.164 6.91 4.562 9.041 7.723v15.603a15.346 15.346 0 0 1-3.062 3.444c-.327.27-.666.534-1.01.78-4.413 3.175-10.32 4.57-16.06 5.475-11.142 1.755-22.517 2.097-33.844 2.432-9.537.285-19.079.57-28.619.758H77.513a555.6 555.6 0 0 1-22.31-1.036c-13.787-.945-27.93-2.615-39.931-8.446A41.168 41.168 0 0 1 9 122.798V87.795c1.275-1.79 2.58-3.57 3.819-5.377l1.092-1.626z"
        opacity=".3"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M21 63v3h-1c.395-.998.732-1.999 1-3zM40 66h-8v-5h8zM21 71v5h-5a53.17 53.17 0 0 0 2.48-5H21zM40 76h-8v-5h8zM14.035 80H21v5h-8v-3.318zM40 85h-8v-5h8zM13 90h8v5h-8zM40 95h-8v-5h8zM13 99h8v5h-8zM40 104h-8v-5h8zM13 109h8v5h-8zM40 114h-8v-5h8zM13 118h8v5h-8zM40 123h-8v-5h8zM47 107h20v2H47zM47 110h20v2H47zM47 114h20v2H47zM98 108h20v2H98zM98 111h20v2H98zM98 115h20v2H98zM47 117h20v2H47zM47 121h20v2H47zM47 125h20v2H47zM74 81h5v7h-5zM91 88h-5v-7h5zM74 93h5v7h-5zM91 100h-5v-7h5zM74 104h5v7h-5zM91 111h-5v-7h5zM74 115h5v7h-5zM91 122h-5v-7h5zM121 44h7v9h-7zM121 57h7v9h-7zM121 70h7v9h-7zM121 84h7v9h-7zM121 97h7v9h-7zM121 110h7v9h-7zM144 62h27v8h-27zM144 79h27v8h-27zM144 96h27v8h-27zM144 113h27v8h-27zM18.047 45.921v.158c-.03-.051-.062-.107-.094-.158h.094zM201 106.99V110h-9V99c3.596 2.235 6.878 4.717 9 7.99zM201 115v7.656a15.61 15.61 0 0 1-3.047 3.543c-.325.278-.662.549-1.005.801H192v-12h9z"
        opacity=".4"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M62.074 36h-1.38c.533 0 .965-.448.965-1s-.432-1-.965-1H49.517c-.534 0-.966.448-.966 1s.432 1 .966 1h1.38c-.518.022-.926.464-.926 1s.408.978.926 1h-1.931c-.534 0-.966.448-.966 1s.432 1 .966 1H60.14c.533 0 .966-.448.966-1s-.433-1-.966-1h1.933c.518-.022.926-.464.926-1s-.408-.978-.926-1zM111.074 61h-1.38c.534 0 .966-.448.966-1s-.432-1-.966-1H98.52c-.533 0-.966.448-.966 1s.433 1 .966 1h1.376c-.518.022-.926.464-.926 1s.408.978.926 1h-1.93c-.534 0-.966.448-.966 1s.432 1 .965 1h11.177c.533 0 .965-.448.965-1s-.432-1-.965-1h1.932c.518-.022.926-.464.926-1s-.408-.978-.926-1zM195.034 29h-1.38c.534 0 .966-.448.966-1s-.432-1-.966-1h-11.177c-.533 0-.966.448-.966 1s.433 1 .966 1h1.38c-.533 0-.966.447-.966.999s.433 1 .966 1h-1.931c-.518.022-.926.463-.926 1 0 .536.408.977.926 1h11.176a.96.96 0 0 0 .872-.487c.182-.316.182-.71 0-1.026a.96.96 0 0 0-.872-.488h1.932c.534 0 .966-.447.966-1 0-.551-.432-.999-.966-.999z"
        opacity=".1"
      />
      <path
        fill="url(#a)"
        fillRule="nonzero"
        d="M179.815 76.399l.011-.016-.043-.029-.087-.059a.06.06 0 0 1 .016.014.358.358 0 0 0-.47.1l-.054.073-2.5 3.583-.438.63c-1.315-.397-3.452 1.268-4.536 2.222l-.19.17a13.697 13.697 0 0 1-.135-.315c-.054.585-2.128 1.464-2.612 1.783a1.778 1.778 0 0 1-.715.242c.068-2.23-1.657-4.575-1.657-4.575l-4.218-5.362a4.721 4.721 0 0 1 .541-3.051H162.93c.344 0 .688-.03 1.027-.09a5.617 5.617 0 0 0 4.632-5.175c.426-.109.786-.503.726-.956a.711.711 0 0 0 0-.26.957.957 0 0 0-.049-.158c-.12-.305-.376-.551-.562-.83a2.55 2.55 0 0 1-.402-1.363c.016-.422.082-.84.196-1.247.085-.243.126-.5.12-.756v-.052a.952.952 0 0 0-.043-.342 1.34 1.34 0 0 0-.564-.688c-.668-.435-1.524-.442-2.274-.713-1.09-.398-2.075-1.38-3.216-1.143-.622.129-1.099.605-1.636.94a3.963 3.963 0 0 1-1.974.599c-.588.017-1.183-.097-1.762 0a1.842 1.842 0 0 0-.305.082 4.552 4.552 0 0 0-1.53-.241 2.579 2.579 0 0 0-1.443.397c-.782.544-.99 1.605-.979 2.548a.094.094 0 0 0 0 .023v.178c0 .453.045.913.054 1.365.004.423-.056.843-.179 1.248-.357 1.12-1.392 1.975-1.599 3.135-.035.2-.047.403-.036.606-.014.656.197 1.314.392 1.95.403 1.315.714 2.713.725 4.078a6.715 6.715 0 0 1-.498 2.472c-.097.23-.217.45-.358.654a2.969 2.969 0 0 1-.146.19l-.02.023a2.19 2.19 0 0 1-.141.146l-.04.037c-.046.04-.094.079-.144.114l-.048.036a1.528 1.528 0 0 1-.211.12l.357-.022c-.109.09-.229.167-.357.228l1.897-.11c.005.02.008.04.01.062a.953.953 0 0 1-.074.27v.017a1.089 1.089 0 0 1-.147.237l-.016.018c-.029.036-.06.07-.094.101a.94.94 0 0 1-.104.08l-.023.018a1.002 1.002 0 0 1-.24.112l-.032.01a.788.788 0 0 1-.132.025l.179-.02c.12-.014.24-.03.357-.05h.036a.957.957 0 0 1-.572.283 5.245 5.245 0 0 0 1.202-.237c.247 1.656.795 6.702.493 7.634-.323.993.502 8.272.502 8.272s.113.558.31 1.39c-.508 1.197-1.087 2.52-1.378 3.05-.582 1.07-.296 6.499 1.715 8.912 0 0 .832 1.171.613 1.605-.22.433.037 1.172.037 1.172l.318 7.03a18.14 18.14 0 0 1-.148 2.148c-.856 1.06-2.18 2.606-2.801 2.852-.963.39-8.144 9.09-8.144 9.09s.057.105.17.276l-.203.234-1.377 1.593-.109.127c-.259-.049-1.98-.357-3.348-.46l-.134-.01v-.022a5.085 5.085 0 0 0-1.443.037h-.01a.47.47 0 0 0-.238.125c-.467.568-.715 9.518-.715 9.518s.497 4.47 2.04 4.727c.08.028.165.044.25.048h.002a.697.697 0 0 0 .086 0c1.107-.08 1.608-.713 1.838-1.15.067-.131.119-.27.154-.413 0 0-.179-.799.305-1.899s1.383-3.019 1.383-3.019 1.642-1.723 1.349-2.56l.157-.226c.618-.877 1.863-2.61 2.87-3.766l.197-.223c.367.156.752.267 1.145.332 0 0 1.544-.603 2.119-1.96.245-.575 1.202-1.59 2.222-2.571l-.032.262-.036 8.555c.332.228.686.422 1.056.58v.214a27.535 27.535 0 0 1-.22 3.648l-.032.19c-.127-.092-.236-.122-.307-.05-.316.318-.513 2.36-.536 3.302v.053c-.021.389-.125.852-.125 1.266-.01.6.179 1.107 1.152 1.15 1.21.05 6.412.13 9.197.178a6.186 6.186 0 0 0 4.109-1.453c.51-.437.902-.921.914-1.38.025-.356-.166-.69-.698-.982a.208.208 0 0 1-.011.036 2.998 2.998 0 0 0-.227-.11l-2.68-.42-4.555-2.318s-.027-1.405-.573-1.171c-.163.034-.32.094-.463.178-.027-.053-.055-.107-.082-.164a5.254 5.254 0 0 1-.563-2.37c0-.075 0-.15.01-.227.135-.12.262-.25.38-.387 0 0-.036-3.195.321-3.8.357-.604 1.474-6.712 1.474-6.712s.036-1.136.754-1.811c.718-.676.466-2.627.466-2.627s1.004-.535 1.327-2.273c.324-1.738 1.365-5.54 1.365-5.54s2.155-5.61 2.012-9.161c-.143-3.55.214-5.397.214-5.397l.448-8.25v-.13c.179.138.299.247.299.247v-.09l.103.09s.229-3.743.152-5.228c1.25-.426 3.17-1.126 3.276-1.483.163-.535 2.323-2.21 2.323-2.21a.397.397 0 0 1-.13-.05c.067-.03.137-.068.212-.107 1.411-.756 4.036-2.96 3.594-4.31l2.87-4.117a.7.7 0 0 0-.06-.873zm-23.373-4.004c-.07.001-.14.007-.21.016a15.798 15.798 0 0 0-.535-2.169c-.333-1.116-.69-2.238-.743-3.399v-.151c.005-.306.045-.61.12-.908a4.5 4.5 0 0 0 .223.37c.459.691.995 1.349 1.277 2.128.129.356.204.743.4 1.069.197.326.56.602.942.544a.74.74 0 0 0 .357-.163 15.056 15.056 0 0 1-1.831 2.663z"
      />
      <path
        fill="#ECB4B6"
        fillRule="nonzero"
        d="M172.36 86.753a2.041 2.041 0 0 1-.7.247c-.922.024-1.66-2.272-1.66-2.272s.26-.245.674-.588c1.223-1.01 3.791-2.876 4.995-1.832 1.345 1.17-1.737 3.655-3.309 4.445zM159 143.702L155.606 147s-3.142.032-2.526-1.528c.12-.338.208-.685.26-1.037.156-1.11.23-2.229.222-3.348 0-.731-.013-1.244-.013-1.244s4.945-1.95 4.44.08c-.066.26-.101.524-.105.79a4.45 4.45 0 0 0 .558 2.167 4.9 4.9 0 0 0 .558.822z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M159 143.803L155.606 147s-3.142.03-2.526-1.482c.12-.327.208-.663.26-1.004.449.302 1.094 1.194 1.094 1.194s2.165.552 2.76-1.102c.335-.924.86-1.382 1.26-1.606.151.283.334.552.546.803z"
        opacity=".1"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M167.107 148.506a5.877 5.877 0 0 1-4.011 1.493c-2.716-.041-7.791-.123-8.97-.174-1.577-.07-1.053-1.463-1.003-2.426v-.097c.018-.959.211-3.041.52-3.359.308-.317 1.391 1.449 1.391 1.449s2.1.634 2.678-1.268c.577-1.901 1.757-2.097 1.757-2.097.541-.239.561 1.194.561 1.194l4.448 2.374 2.609.425c.084.04.16.08.232.12 1.171.675.652 1.594-.212 2.366z"
      />
      <ellipse
        cx="159"
        cy="145"
        fill="#32B496"
        fillRule="nonzero"
        opacity=".25"
        rx="1"
        ry="1"
      />
      <ellipse
        cx="160"
        cy="146"
        fill="#FFF"
        fillRule="nonzero"
        opacity=".25"
        rx="1"
        ry="1"
      />
      <ellipse
        cx="161"
        cy="146"
        fill="#FFF"
        fillRule="nonzero"
        opacity=".25"
        rx="1"
        ry="1"
      />
      <ellipse
        cx="163"
        cy="147"
        fill="#FFF"
        fillRule="nonzero"
        opacity=".25"
        rx="1"
        ry="1"
      />
      <ellipse
        cx="162"
        cy="147"
        fill="#FFF"
        fillRule="nonzero"
        opacity=".25"
        rx="1"
        ry="1"
      />
      <path
        fill="#30AD90"
        fillRule="nonzero"
        d="M167.107 148.448c-1.115 1.028-2.542 1.58-4.011 1.551-2.716-.043-7.791-.128-8.97-.18-1.577-.074-1.053-1.52-1.003-2.52l9.899.659s4.054-.661 4.296-1.958c1.173.692.653 1.646-.211 2.448z"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M167.107 148.46c-1.117 1.023-2.544 1.57-4.011 1.539-2.716-.043-7.791-.126-8.97-.18-1.577-.074-1.053-1.52-1.003-2.519l9.899.657s4.054-.66 4.296-1.957c1.173.705.653 1.658-.211 2.46z"
        opacity=".25"
      />
      <path
        fill="#ECB4B6"
        fillRule="nonzero"
        d="M148.804 135.153c-.36.274-.69.582-.983.918-.97 1.054-2.17 2.632-2.767 3.43l-.37.499-1.3-.18s-1.402-1.998-1.384-2.052c.018-.053 1.108-2.198 1.108-2.198l.423-.462 1.33-1.452.602-.656s4.519 1.36 3.341 2.153z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M145 139.49l-.364.51-1.276-.184s-1.377-2.043-1.36-2.097c.018-.055 1.088-2.247 1.088-2.247l.416-.472.136.024h.323c-1.14 1.156.086 3.7.086 3.7s.529.052.951.765z"
        opacity=".1"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M143.67 141.72s-.861 1.857-1.325 2.924c-.465 1.066-.293 1.84-.293 1.84a1.772 1.772 0 0 1-.147.4 2.029 2.029 0 0 1-1.844 1.114c-1.561-.04-2.061-4.593-2.061-4.593s.24-8.667.687-9.214a.42.42 0 0 1 .227-.12c.456-.08.921-.092 1.38-.038 1.418.1 3.243.45 3.243.45h.326c-1.152 1.203.085 3.852.085 3.852s.551.052.982.826c.43.774-1.26 2.559-1.26 2.559z"
      />
      <ellipse
        cx="141"
        cy="139"
        fill="#FFF"
        fillRule="nonzero"
        opacity=".25"
        rx="1"
        ry="1"
      />
      <ellipse
        cx="141"
        cy="141"
        fill="#FFF"
        fillRule="nonzero"
        opacity=".25"
        rx="1"
        ry="1"
      />
      <path
        fill="#30AE91"
        fillRule="nonzero"
        d="M142 146.885c-.218.42-.727 1.035-1.806 1.115h-.074c-1.608-.04-2.12-4.594-2.12-4.594s.247-8.668.705-9.215a.441.441 0 0 1 .232-.12 5.067 5.067 0 0 1 1.417-.038c-.027 1.556-.102 6.483 0 6.972.102.49 1.007 4.569 1.646 5.88z"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M142 146.883a2.078 2.078 0 0 1-1.887 1.115c-1.604-.04-2.113-4.593-2.113-4.593s.246-8.667.703-9.214a.44.44 0 0 1 .232-.12 5.04 5.04 0 0 1 1.414-.038c-.027 1.556-.103 6.482 0 6.971.103.489 1.011 4.568 1.651 5.88z"
        opacity=".25"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M140 148c-1.517-.041-2-4.617-2-4.617s.233-8.711.665-9.262a.408.408 0 0 1 .219-.121c.319.492.598 1.58.343 3.976-.473 4.538.097 4.823.097 4.823s.701 3.847.675 5.201z"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M139.999 148c-1.521-.041-1.999-4.62-1.999-4.62s.233-8.709.665-9.259a.408.408 0 0 1 .219-.121c.318.491.596 1.58.342 3.975-.472 4.537.098 4.822.098 4.822s.71 3.85.675 5.203z"
        opacity=".1"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M172 86.74c-.181.13-.382.218-.593.26-.782.025-1.407-2.383-1.407-2.383s.22-.257.57-.617c.243.658.942 2.415 1.43 2.74z"
        opacity=".1"
      />
      <path
        fill="#FF748E"
        fillRule="nonzero"
        d="M166.798 86.014s.678.052 1.113-.263c.436-.314 2.299-1.176 2.347-1.751 0 0 1.114 2.928 1.742 3.032 0 0-1.935 1.649-2.08 2.172C169.772 89.726 166 91 166 91l.798-4.986z"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M166.798 86.014s.678.052 1.113-.263c.436-.314 2.299-1.176 2.347-1.751 0 0 1.114 2.928 1.742 3.032 0 0-1.935 1.649-2.08 2.172C169.772 89.726 166 91 166 91l.798-4.986z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M148.81 134.103a6.384 6.384 0 0 0-.95.897c-1.512-.6-2.49-1.82-2.86-2.358l.581-.642s4.368 1.327 3.23 2.103z"
        opacity=".1"
      />
      <path
        fill="#5E5A6B"
        fillRule="nonzero"
        d="M156 120s-2.47 3.427-3.37 3.816c-.902.39-7.63 8.963-7.63 8.963s1.443 2.776 4.11 3.221c0 0 1.447-.595 1.985-1.924.537-1.33 4.777-5.078 4.777-5.078L156 120z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M156 120s-2.47 3.427-3.37 3.816c-.902.39-7.63 8.963-7.63 8.963s1.443 2.776 4.11 3.221c0 0 1.447-.595 1.985-1.924.537-1.33 4.777-5.078 4.777-5.078L156 120z"
        opacity=".1"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M148 130.865c.791.082 1.589.082 2.38 0 1.406-.129.339.698-2.38 0zM148 132s2.016 1.563 2.794.781c.777-.781-.75.755-2.794-.781zM157.968 139.102a5.414 5.414 0 0 0-.092.933c-1.307 1.43-2.88.989-3.864.466 0-.874-.012-1.487-.012-1.487s4.42-2.34 3.968.088z"
        opacity=".1"
      />
      <path
        fill="#5E5A6B"
        fillRule="nonzero"
        d="M167 94.275l-.051.96-.428 8.058s-.353 1.803-.207 5.271c.147 3.469-1.908 8.949-1.908 8.949s-.993 3.713-1.301 5.412c-.309 1.7-1.266 2.22-1.266 2.22s.24 1.908-.444 2.565c-.684.658-.717 1.77-.717 1.77s-1.058 5.965-1.41 6.555c-.353.59-.309 3.711-.309 3.711-2.224 2.672-5.474.243-5.474.243l.034-8.358s.925-7.7 1.609-8.776c.684-1.075.684-4.023.684-4.023l-.305-6.867s-.244-.73-.034-1.146c.21-.416-.585-1.556-.585-1.556-1.916-2.359-2.189-7.665-1.634-8.707.555-1.042 2.22-5.202 2.22-5.202l2.29-1.354 4.137.125 5.099.15z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M157 135s.51 1.792.921 1.988c.411.195-.921-1.988-.921-1.988zM158 129s1.359 1.003 1.918 1c.559-.003-1.918-1-1.918-1z"
        opacity=".1"
      />
      <path
        fill="#ECB4B6"
        fillRule="nonzero"
        d="M166 82.677V85l-1.494-.66-1.489-.66-3.238-3.273s-2.562-1.71-3.934-3.265c-.784-.888-1.18-1.728-.488-2.176.334-.225.635-.497.896-.807.69-.834 1.29-1.742 1.788-2.709l.064-.118c.667-1.258 1.107-2.332 1.107-2.332s1.879.618 3.089 1.494c.097.07.189.142.277.216.674.568 1.008 1.224.388 1.88a4.88 4.88 0 0 0-.443.545c-.1.142-.192.29-.274.444a4.849 4.849 0 0 0-.517 3.025L166 82.677z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M162.685 72.753a5.039 5.039 0 0 0-.422.568 4.409 4.409 0 0 0-.26.465 8.366 8.366 0 0 0-.1.214c-1.527-.095-2.936-.954-3.843-2.343a.97.97 0 0 1-.06-.096l.06-.124c.635-1.315 1.054-2.437 1.054-2.437s1.787.646 2.938 1.562c.092.072.18.148.263.225.642.594.968 1.28.37 1.966z"
        opacity=".1"
      />
      <path
        fill="#ECB4B6"
        fillRule="nonzero"
        d="M168 67.498A5.494 5.494 0 0 1 162.5 73H162.297A5.5 5.5 0 0 1 157 67.57a5.5 5.5 0 1 1 11-.071z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M162.963 80.945s2.686 1.516 1.997.237L161.457 76l3.977 5.114s2.539 3.49 1.151 5.892c0 0-.204 2 .033 2.472.237.473-.068 5.522-.068 5.522s-.947-.872-1.454-.712c-.507.16-4.096.475-4.096.475l1.963-13.818z"
        opacity=".1"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M166 94.129l-.049.804c-.307-.201-.737-.426-1.022-.34-.486.15-3.929.407-3.929.407l.159-1 4.841.129z"
        opacity=".1"
      />
      <path
        fill="#464353"
        fillRule="nonzero"
        d="M162.963 80.945s2.686 1.516 1.997.237L161.457 76l3.977 5.114s2.539 3.49 1.151 5.892c0 0-.202 2 .033 2.472.236.473-.066 5.522-.066 5.522s-.949-.872-1.456-.712c-.507.16-4.096.475-4.096.475l1.963-13.818z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M164.966 83.935c-.162 1.651-.854 3.616-.854 3.616s-.489 4.88-1.12 6.324c-.63 1.444-.35 3.435-.699 7.111-.126 1.323-.56 2.232-1.146 2.847-.962 1.008-2.343 1.22-3.424 1.157-.089 0-.18-.01-.258-.02-1.75-.176-3.424-8.45-3.424-8.45s-.804-7.044-.49-8.006c.313-.963-.314-6.459-.525-7.663-.133-.76.269-2.007.579-2.815.18-.47.331-.792.331-.792s.595-1.855 1.574-2.816c.272-.275.647-.43 1.038-.428.46.017.908.154 1.296.398l.045.03s6.367 6.39 6.961 7.868c.163.41.179 1.002.116 1.639z"
        opacity=".1"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M164.966 83.935c-.162 1.651-.854 3.616-.854 3.616s-.49 4.88-1.12 6.322c-.63 1.443-.36 3.436-.7 7.112-.126 1.324-.56 2.233-1.146 2.848-.964 1.008-2.344 1.22-3.425 1.157l-.256-.02c-1.75-.176-3.425-8.45-3.425-8.45s-.804-7.045-.489-8.006c.315-.961-.315-6.459-.525-7.663-.133-.76.267-2.007.58-2.817.18-.468.329-.79.329-.79s.595-1.855 1.576-2.817a1.456 1.456 0 0 1 1.036-.427c.461.017.91.154 1.298.398l.045.029s6.37 6.39 6.963 7.867c.158.421.176 1.004.113 1.64z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M158 109s-1.434 1.041-1.933.999C155.57 109.956 158 109 158 109zM158 110.024s-1.48.843-1.93.968c-.448.124 1.358-1.185 1.93-.968zM163 91.035s2.571.027 2.96.782c.388.755-2.122-1.09-2.96-.782zM164 92s1.492.41 1.943.896C166.395 93.383 164 92 164 92zM160 88s-.177 7.026-.833 7.935C158.511 96.843 160 88 160 88z"
        opacity=".1"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M158.363 108.459s-1.46 6.136 1.475 6.526c2.935.39 2.03-6.985 2.03-6.985l-3.505.459z"
        opacity=".1"
      />
      <path
        fill="#ECB4B6"
        fillRule="nonzero"
        d="M158.363 107.459s-1.46 6.138 1.474 6.526c2.934.388 2.032-6.985 2.032-6.985l-3.506.459z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M161.5 82.205c-.156-3.682-5.642-4.443-6.923-.96l-.026.071c-.836 2.358-.472 8.33-.472 8.33s.108 4.009.51 5.342c.401 1.333 1.528 5.161 1.528 5.778 0 .616 1.046 2.974 1.487 3.145.44.17.663 1.504.77 1.743.107.24.437 3.346.437 3.346s4.112-.24 4.185-.854c.073-.615-.91-3.62-.91-3.62s-.725-1.233-.817-2.223c-.092-.99-.675-1.435-.562-2.113.112-.678-.328-1.027-.328-1.47 0-.444-.327-1.642-.327-1.642s-.691-.512-.583-1.127c.109-.614-.982-1.845-.692-2.289.291-.444.364-1.537.364-1.537s.364-4.93.619-6.257c.255-1.326 1.747-3.485 1.747-3.485l-.007-.178z"
        opacity=".1"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M161 103.842c-.904 1-2.196 1.21-3.21 1.148-.116-.465-.288-1.036-.54-1.145-.397-.175-1.339-2.521-1.339-3.134s-1.013-4.432-1.377-5.762c-.363-1.329-.459-5.327-.459-5.327s-.338-5.955.42-8.311c0-.025.014-.048.023-.072 1.153-3.474 6.095-2.713 6.235.958v.176s-1.35 2.148-1.572 3.477c-.221 1.33-.56 6.237-.56 6.237s-.065 1.092-.327 1.535c-.262.442.721 1.67.623 2.283-.098.612.524 1.123.524 1.123s.296 1.193.296 1.637c0 .444.393.783.295 1.466-.098.683.428 1.124.507 2.108a5.67 5.67 0 0 0 .461 1.603z"
        opacity=".1"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M160.5 82.206c-.156-3.682-5.641-4.444-6.922-.961 0 .025-.02.047-.027.072-.836 2.358-.472 8.33-.472 8.33s.109 4.01.508 5.343c.4 1.333 1.53 5.165 1.53 5.777 0 .613 1.045 2.973 1.488 3.144.442.17.663 1.505.77 1.743.107.238.435 3.346.435 3.346s4.115-.24 4.186-.856c.072-.616-.91-3.622-.91-3.622s-.723-1.233-.817-2.223c-.094-.99-.675-1.435-.563-2.113.113-.678-.328-1.026-.328-1.47 0-.444-.328-1.641-.328-1.641s-.692-.513-.581-1.128c.11-.614-.985-1.847-.692-2.289.292-.442.363-1.537.363-1.537s.364-4.931.62-6.257c.254-1.326 1.747-3.487 1.747-3.487l-.007-.17z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M154 92c.112-.124 2.244-2.73 2.916-1.8.672.932-2.916 1.8-2.916 1.8zM155 93c.062-.051 1.584-.103 1.96-.812.374-.708-1.96.812-1.96.812z"
        opacity=".1"
      />
      <g fill="#000" fillRule="nonzero" opacity=".1">
        <path d="M152.49 73.707a.55.55 0 0 1 .097.191.89.89 0 0 0-.097-.727c-.087-.11-.213-.173-.292-.287 0-.01-.01-.02-.016-.031a.588.588 0 0 0 .016.56c.079.112.205.178.292.294zM154.958 66.84c0-.202.009-.402 0-.6-.035-.727-.156-1.455-.185-2.182-.038.884.142 1.818.185 2.711v.071z" />
      </g>
      <path
        fill="#464353"
        fillRule="nonzero"
        d="M173.083 85.872l.113.077a.433.433 0 0 1-.117-.612l5.087-7.148a.464.464 0 0 1 .63-.111l-.112-.077a.687.687 0 0 1 .188.98l-4.77 6.71a.746.746 0 0 1-1.02.18v.001z"
      />
      <path
        fill="#9F9EFF"
        fillRule="nonzero"
        d="M178.594 77.617l.114.079-5.275 7.65-.114-.078a.309.309 0 0 1-.08-.43l4.921-7.136a.309.309 0 0 1 .434-.085z"
      />
      <path
        fill="#464353"
        fillRule="nonzero"
        d="M178.03 78.68c.02.014.024.04.01.06l-.38.553a.044.044 0 0 1-.072-.05l.381-.552a.044.044 0 0 1 .06-.01z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M168.985 67.069c-.077-.369-.382-.638-.592-.952-.524-.781-.442-1.814-.198-2.72.09-.247.128-.51.112-.772a1.222 1.222 0 0 0-.577-.8c-.644-.418-1.47-.424-2.191-.688-1.05-.384-2-1.33-3.095-1.102-.6.125-1.06.584-1.576.906a3.83 3.83 0 0 1-1.904.577c-.567.017-1.14-.092-1.698 0-.1.018-.198.044-.294.08a4.463 4.463 0 0 0-1.474-.234 2.5 2.5 0 0 0-1.39.385c-.755.529-.956 1.542-.944 2.454.013.91.168 1.85-.116 2.718-.356 1.08-1.34 1.904-1.54 3.021-.135.76.118 1.527.344 2.265.65 2.116 1.079 4.464.218 6.51-.22.518-.548 1.031-1.07 1.27l1.83-.108a.975.975 0 0 1-.183.731.997.997 0 0 1-.652.39 4.287 4.287 0 0 0 1.342-.305c.434-.179.75-.557.847-1.012.036-.245-.018-.5.052-.737.12-.407.535-.63.882-.892.892-.687 1.316-1.845 1.35-2.965.034-1.119-.266-2.219-.587-3.294-.32-1.076-.665-2.156-.713-3.275-.02-.41.018-.82.114-1.219.066.122.14.242.216.353.442.666.96 1.3 1.23 2.05.096.356.225.702.385 1.035.19.317.535.58.908.529.372-.051.643-.45.766-.823.123-.374.178-.781.405-1.1.435-.603 1.305-.658 2.054-.635 1.577.05 3.754.285 4.991-.913.236-.228.357-.575.714-.49.328.076.511.604.862.722.574.196 1.302-.333 1.172-.96z"
        opacity=".1"
      />
      <path
        fill="#464353"
        fillRule="nonzero"
        d="M168.985 67.07c-.077-.37-.382-.64-.592-.953-.524-.782-.442-1.815-.198-2.72.09-.247.128-.51.112-.772a1.222 1.222 0 0 0-.577-.8c-.644-.418-1.47-.425-2.191-.688-1.05-.384-2-1.33-3.095-1.102-.6.125-1.06.584-1.576.906a3.848 3.848 0 0 1-1.904.577c-.567.018-1.14-.092-1.698 0-.1.018-.198.044-.294.08a4.463 4.463 0 0 0-1.474-.233 2.517 2.517 0 0 0-1.39.382c-.755.529-.956 1.544-.944 2.456.013.911.168 1.85-.116 2.718-.356 1.081-1.34 1.904-1.54 3.022-.135.76.118 1.527.344 2.265.65 2.116 1.079 4.464.218 6.509-.22.52-.548 1.033-1.07 1.271l1.83-.107a.974.974 0 0 1-.183.73.995.995 0 0 1-.652.389c.461-.027.915-.13 1.342-.303.434-.179.75-.558.847-1.012.036-.245-.018-.5.052-.737.12-.407.535-.631.882-.892.892-.688 1.316-1.846 1.35-2.965.034-1.12-.266-2.222-.587-3.295-.32-1.074-.665-2.156-.713-3.276-.02-.41.018-.82.114-1.218.066.122.14.242.216.353.442.666.96 1.299 1.23 2.05.095.355.224.701.385 1.033.19.317.535.582.908.529.372-.053.643-.448.766-.822.123-.373.178-.78.405-1.1.435-.603 1.305-.657 2.054-.634 1.577.049 3.754.285 4.991-.914.236-.227.357-.574.714-.49.328.076.511.605.862.723.574.196 1.302-.333 1.172-.96z"
      />
      <g fill="#000" fillRule="nonzero" opacity=".1">
        <path d="M153.216 63.486v.358c0 .388.032.78.046 1.17.016-.503-.028-1.017-.046-1.528zM152.599 75.676c.047-1.434-.274-2.912-.687-4.301a8.27 8.27 0 0 1-.353-1.531c-.075.717.152 1.434.353 2.14.383 1.196.614 2.437.687 3.692zM167.913 64.03c.03-.34.088-.68.176-1.01a2 2 0 0 0 .112-.785.873.873 0 0 0-.034-.138c-.021.106-.05.21-.078.313a4.848 4.848 0 0 0-.176 1.62zM152.885 79.179l-1.094.064a1.828 1.828 0 0 1-.717.653l1.708-.102a.945.945 0 0 0 .103-.615zM168.824 66.596a.943.943 0 0 1-1.114.529c-.353-.12-.53-.658-.854-.735-.353-.086-.473.269-.706.5-1.223 1.217-3.378.977-4.941.927-.741-.024-1.603.032-2.033.645-.23.324-.28.74-.4 1.12-.12.38-.371.774-.76.835-.388.061-.705-.21-.898-.537a6.156 6.156 0 0 1-.38-1.05c-.27-.764-.78-1.41-1.219-2.087a4.549 4.549 0 0 1-.213-.359 4.449 4.449 0 0 0-.113 1.24v.089c.014-.242.05-.482.106-.717.065.123.137.245.213.358.438.678.95 1.321 1.218 2.085.094.361.222.713.381 1.05.187.323.53.592.898.538.37-.054.637-.455.76-.835.121-.38.176-.795.4-1.119.43-.613 1.292-.669 2.033-.645 1.562.05 3.716.29 4.94-.929.234-.231.354-.584.707-.498.325.077.506.615.854.735.57.195 1.29-.343 1.161-.98a1.247 1.247 0 0 0-.04-.16zM155.15 77.322c-.335.265-.755.493-.873.907-.069.242-.016.5-.051.75a1.429 1.429 0 0 1-.838 1.03 2.633 2.633 0 0 1-.52.179.992.992 0 0 1-.81.737 4.1 4.1 0 0 0 1.33-.309c.429-.181.742-.566.838-1.028.035-.25-.018-.51.051-.75.118-.414.53-.641.874-.907.882-.699 1.302-1.876 1.335-3.015v-.507c-.063 1.104-.481 2.235-1.335 2.913z" />
      </g>
      <path
        fill="url(#b)"
        fillRule="nonzero"
        d="M80.855 145.251h.04s-6.457-17.588-8.265-19.977c0 0-1.894-1.111-1.807-2.989L68.5 111.091s.035-.034.093-.097l.049-.055c.018-.02.037-.04.056-.065.31-.362.57-.764.772-1.196.013-.028.027-.055.039-.083a4.51 4.51 0 0 0 .216-.604c.163.057.34.047.496-.027v-.167s-.023-.663-.024-1.698v-.938c.075-.268.136-.54.184-.815l-.095-.045c0-.014 0-.026.009-.04l-.08-.037c.064-2.455.275-5.592.88-7.73.021-.075.042-.15.065-.224.718-2.333.734-5.182.918-7.594.145.302.27.613.373.932.091-.101.197-.188.313-.26l.721 5.725v6.743s-1.206 8.71 2.582 7.088c3.788-1.621 1.034-7.595 1.034-7.595s0-3.329.517-5.037c.34-1.123.12-4.769-.07-7.116.362.066.585.117.585.117.084-.343.122-.695.112-1.048.078-3.935-4.816-10.279-6.812-12.699a5.709 5.709 0 0 0-2.299-2.002l-3.828-1.84s-1.803-.45-2.506-1.827c0-.023-.012-.048-.018-.073.08-.035.159-.072.236-.113a4.255 4.255 0 0 0 1.497-1.194c.816-1.027 1.204-2.315 1.582-3.569.438-1.473.88-2.98.822-4.516-.058-1.537-.704-3.133-2.025-3.95-1.123-.695-2.688-.828-3.385-1.942-.188-.3-.302-.657-.554-.901a.212.212 0 0 0-.176-.217l-1.952-.378a.213.213 0 0 0-.248.166v.026a11.742 11.742 0 0 0-4.953 1.249 11.43 11.43 0 0 0-1.569.918c-.703.499-1.407 1.156-1.505 2.01-.051.426.052.862-.036 1.28-.232 1.115-1.739 1.841-1.519 2.96.148.759 1.015 1.085 1.825 1.087a6.03 6.03 0 0 0-.226 1.634 6.078 6.078 0 0 0 4.873 5.936c.59.823 1.107 1.697 1.545 2.61-.991.935-3.068 3.104-1.795 3.833l-2.638 6.49.257 6.691-1.117.991.245.304c-1.25 1.445-4.149 4.605-6.266 5.445a6.495 6.495 0 0 0-.88.431c-.388.244-.819.411-1.27.493-.196.02-.39.057-.581.111l-.505-1.04a.758.758 0 0 0-1.01-.353l-.309.148-.737.353-.306.147-.234.111a.746.746 0 0 0-.351 1.002l.612 1.259c-.87.761-1.296 1.67-.111 2.515.46.333 1.015.507 1.583.495l.372.764a.756.756 0 0 0 1.008.354l.54-.258 1.055-.5a.742.742 0 0 0 .352-1l-.306-.63a12.41 12.41 0 0 0 1.87-1.78s1.571-.977 2.496-1.195c.614-.144 2.768-1.545 4.094-2.432l.378 9.86a2.204 2.204 0 0 1-.292.352l.298-.208v.072c-.044.05-.087.096-.129.136l.129-.091v.118c-.041.05-.086.099-.134.143l.135-.095.039 1.024.649-1.06.04 1.06.152-.249c-1.819 3.064-4.188 7.575-5.452 12.116 0 0-1.978 3.414-1.722 6.915l-3.64 17.326.07.027c-1.18.842-3.659 2.388-6.095 2.45 0 0-5.854-.177-4.22 1.109 1.634 1.285 16.179 3.16 16.179 3.16l.559-4.317.13.048s0-.025-.009-.068l.176.068s-.352-2.136.946-3.33 4.305-13.319 4.045-15.19c0 0 2.31-5.727 5.203-10.294l3.405 8.674 3.788 6.489s5.038 11.109 4.876 13.585c-1.055 1.282-2.95 3.29-4.36 3.232 0 0-5.767 1.111-1.807 2.136C70.38 152.85 82 149 82 149l-1.145-3.75zm-25.22-39.724l.036-.019c-.176.274-.371.58-.579.913l.544-.894z"
      />
      <path
        fill="url(#c)"
        fillRule="nonzero"
        d="M53.111 106.92c-.144.101-.222.16-.222.16a.927.927 0 0 0 .222-.16z"
      />
      <path
        fill="url(#d)"
        fillRule="nonzero"
        d="M53.111 106.92l-.222.16a.938.938 0 0 0 .222-.16z"
      />
      <path
        fill="url(#c)"
        fillRule="nonzero"
        d="M53.111 106.92c-.144.101-.222.16-.222.16a.927.927 0 0 0 .222-.16z"
      />
      <path
        fill="#333"
        fillRule="nonzero"
        d="M73.373 145.832s-3.103 4.084-5.172 4.003c0 0-5.78 1.04-1.806 2.002 3.974.961 15.605-2.643 15.605-2.643L80.616 145l-7.243.832z"
      />
      <path
        fill="#535461"
        fillRule="nonzero"
        d="M59 115.987l4.318 11.055 3.727 6.413s5.125 11.35 4.791 13.545L80 145.691s-6.352-17.383-8.13-19.746c0 0-1.863-1.098-1.775-2.954l-2.285-11.047s2.223-2.137.981-4.816a4.49 4.49 0 0 0-.22-.416c-1.693-2.868-8.13-1.266-8.13-1.266L59 115.986z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M59 115.987l4.318 11.055 3.727 6.413s5.125 11.35 4.791 13.545L80 145.691s-6.352-17.383-8.13-19.746c0 0-1.863-1.098-1.775-2.954l-2.285-11.047s2.223-2.137.981-4.816a4.49 4.49 0 0 0-.22-.416c-1.693-2.868-8.13-1.266-8.13-1.266L59 115.986z"
        opacity=".03"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M71.838 125.924s-1.846-1.096-1.758-2.949l-2.27-11.024s2.203-2.133.972-4.807a4.492 4.492 0 0 0-.218-.415c-.814-1.388-2.732-1.727-4.494-1.708 1.69.016 3.468.387 4.243 1.708.08.134.152.273.216.415 1.231 2.674-.97 4.807-.97 4.807l2.264 11.033c-.082 1.853 1.759 2.949 1.759 2.949 1.758 2.358 8.054 19.706 8.054 19.706l-7.836 1.253v.04l8.087-1.305s-6.287-17.345-8.049-19.703z"
        opacity=".1"
      />
      <path
        fill="#333"
        fillRule="nonzero"
        d="M44.227 144s-3.419 2.8-6.752 2.882c0 0-5.812-.172-4.189 1.072C34.909 149.198 49.357 151 49.357 151l.643-4.81-5.773-2.19z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M56.864 104.213s-5.497 7.938-7.662 15.961c0 0-1.92 3.415-1.665 6.915l-3.499 17.328 6.413 2.474s-.333-2.134.916-3.329c1.25-1.195 4.164-13.316 3.914-15.194 0 0 3.998-10.243 7.996-14.255 3.997-4.012 5.985-4.939 6.573-8.407 0 .006-9.405-4.652-12.986-1.493z"
        opacity=".1"
      />
      <path
        fill="#535461"
        fillRule="nonzero"
        d="M56.914 104.08s-5.538 7.796-7.719 15.678c0 0-1.934 3.353-1.679 6.792L44 143.57l6.453 2.43s-.335-2.096.923-3.27c1.257-1.173 4.196-13.08 3.943-14.924 0 0 4.028-10.062 8.056-14.003 4.028-3.94 6.032-4.85 6.625-8.257 0 .005-9.478-4.57-13.086-1.467z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M60.37 103.03c4.151.049 9.32 2.548 9.32 2.548-.592 3.398-2.592 4.307-6.61 8.25-4.017 3.941-8.038 13.987-8.038 13.987.251 1.843-2.679 13.738-3.935 14.91-1.093 1.021-.98 2.74-.933 3.168l.263.098s-.335-2.094.92-3.266c1.257-1.172 4.187-13.067 3.936-14.91 0 0 4.02-10.051 8.039-13.988 4.019-3.936 6.019-4.846 6.608-8.249 0 0-5.38-2.6-9.57-2.548z"
        opacity=".1"
      />
      <path
        fill="#ECB4B6"
        fillRule="nonzero"
        d="M52.43 92s-4.15 5.139-6.954 6.255a6.76 6.76 0 0 0-.893.434c-.39.246-.822.416-1.276.5a3.103 3.103 0 0 0-.971.254c-1.458.666-4.817 2.47-2.6 4.055 2.784 1.993 6.524-2.593 6.524-2.593s1.587-.99 2.522-1.21c.935-.221 5.218-3.2 5.218-3.2L52.43 92z"
      />
      <path fill="#32B496" fillRule="nonzero" d="M53.358 91L52 92.308 54 95z" />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M53.381 91.163l-1.295 1.56 1.908 3.212z"
        opacity=".1"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M57.503 74s-3.584 3.283-2.082 4.21L53 84.604 53.833 108l3.418-6.059-2.335-13.128s-.66-7.826 1.25-9.678L58 75.255 57.503 74z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M58.326 73.039s-4.203 3.263-2.444 4.183l-2.836 6.362.978 23.251 4.008-6.022-2.737-13.053s-.774-7.778 1.466-9.618l2.152-3.856-.587-1.247z"
        opacity=".1"
      />
      <path
        fill="#ECB4B6"
        fillRule="nonzero"
        d="M54 70.4s3.142 3.87 3.056 6.107c-.085 2.238 5.944-3.87 5.944-3.87s-2.293-2.84-1.699-5.852C61.895 63.773 54 70.4 54 70.4zM72 90.193l.792 6.817v6.724s-1.107 8.683 2.373 7.065c3.48-1.618.941-7.582.941-7.582s0-3.321.476-5.023c.475-1.701-.237-9.194-.237-9.194L72 90.193z"
      />
      <path
        fill="#F2F2F2"
        fillRule="nonzero"
        d="M60 74s-2.122 2.24-3.235 1.462l-1.515 4.106a20.423 20.423 0 0 0-1.232 7.914L54.554 103l2.368-.344.79-14.716 1.185-8.949L60 74z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M62.897 71.15s-3.052 2.075-3.911 3.856c0 0-.087 1.953-.775 2.797-.688.843-1.375 5.084-1.548 10.17-.173 5.085-.946 11.863-.946 11.863s-1.29 6.61-2.665 7.28c0 0 6.362-4.745 9.458-3.134 3.095 1.61 6.622 5.505 7.654 4.915 0 0-.249-7.428.88-11.39.02-.074.042-.148.066-.221 1.204-3.898.43-9.234 1.802-11.525 0 0 0-4.142-.793-7.236a5.61 5.61 0 0 0-3.036-3.65l-3.82-1.819s-2.022-.296-2.366-1.907z"
        opacity=".1"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M62.741 71.15s-2.89 2.265-3.75 4.058c0 0-.086 1.97-.775 2.82-.688.85-1.38 5.126-1.551 10.25-.172 5.125-.948 11.968-.948 11.968s-1.294 6.662-2.674 7.339c0 0 6.38-4.785 9.483-3.161 3.103 1.623 6.638 5.548 7.671 4.954 0 0-.247-7.485.883-11.479l.065-.224c1.209-3.937.432-9.307 1.807-11.618 0 0 0-4.176-.797-7.292a5.645 5.645 0 0 0-3.042-3.682l-3.834-1.84s-2.193-.47-2.538-2.093z"
        opacity=".1"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M62.699 71s-2.858 2.127-3.724 3.922c0 0-.087 1.96-.778 2.808-.691.846-1.386 5.104-1.559 10.21-.172 5.105-.952 11.902-.952 11.902s-1.3 6.637-2.686 7.31c0 0 6.409-4.764 9.526-3.147 3.118 1.617 6.669 5.526 7.707 4.935 0 0-.249-7.458.887-11.435l.065-.223c1.214-3.913.434-9.27 1.815-11.57 0 0 0-4.158-.8-7.264a5.63 5.63 0 0 0-3.056-3.665l-3.852-1.833s-1.944-.461-2.593-1.95z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M70.69 76.607s8.304 9.503 7.16 14.03c0 0-4.256-.987-5.4.329 0 0-.9-3.045-3.6-4.773-2.7-1.727-5.188-12.795 1.84-9.586z"
        opacity=".1"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M70.635 76.583s8.416 9.542 7.255 14.086c0 0-4.312-.992-5.473.331 0 0-.912-3.057-3.648-4.792-2.737-1.734-5.258-12.848 1.866-9.625z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M61.648 69.364c-.14-.7-.022-.753.134-1.519.622-3.036-7.628 3.637-7.628 3.637s.46.545 1.03 1.349c.42.085.848.127 1.277.127 2.257.007 4.075-1.854 5.187-3.594z"
        opacity=".1"
      />
      <circle cx="57" cy="66" r="6" fill="#ECB4B6" fillRule="nonzero" />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M51.335 64.53c-.91.12-2.064-.178-2.239-1.062-.22-1.117 1.299-1.845 1.533-2.96.09-.419-.016-.855.035-1.28.101-.855.803-1.513 1.518-2.01a11.82 11.82 0 0 1 7.77-2.037c.344.003.68.107.963.299.3.243.414.635.618.959.703 1.118 2.28 1.252 3.412 1.947 1.326.814 1.98 2.412 2.04 3.95.06 1.536-.385 3.041-.827 4.517-.374 1.253-.767 2.542-1.589 3.569-.822 1.027-2.182 1.746-3.478 1.431.593-.42.164-1.394-.478-1.736-.642-.341-1.437-.4-1.984-.871-.547-.47-.713-1.244-.893-1.945-.225-.895-.545-1.79-1.207-2.432-1.282-1.263-3.613-.548-5.194-.338z"
        opacity=".1"
      />
      <path
        fill="#464353"
        fillRule="nonzero"
        d="M51.272 64.512c-.913.123-2.073-.182-2.25-1.074-.221-1.132 1.304-1.868 1.542-2.998.087-.424-.019-.864.032-1.295.103-.866.81-1.53 1.528-2.034a11.814 11.814 0 0 1 7.805-2.063c.345.004.682.11.966.304.302.245.419.641.623.97.705 1.131 2.291 1.267 3.43 1.97 1.329.824 1.988 2.443 2.047 3.997.058 1.554-.387 3.08-.83 4.574-.378 1.267-.77 2.573-1.598 3.613-.827 1.04-2.192 1.766-3.493 1.449.594-.424.163-1.411-.48-1.757-.643-.346-1.443-.404-1.995-.882-.551-.478-.716-1.259-.895-1.969-.226-.896-.548-1.811-1.213-2.46-1.295-1.282-3.631-.557-5.219-.345z"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M60.421 58.57l.575-2.92a.216.216 0 0 0-.174-.254l-2.026-.392a.219.219 0 0 0-.257.171l-.575 2.918L56 65.3l3.601.7.82-7.43z"
      />
      <g fill="#000" fillRule="nonzero" opacity=".1">
        <path d="M50.52 60.464c.125-.195.216-.411.267-.639.085-.425-.018-.869.032-1.3.018-.153.055-.304.108-.449-.164.26-.27.554-.31.86-.049.433.054.875-.033 1.3a1.384 1.384 0 0 1-.064.228zM64.415 69.898c-.791 1.03-2.098 1.75-3.342 1.471a.663.663 0 0 1-.258.4c1.262.315 2.596-.414 3.4-1.454.301-.4.555-.833.757-1.293-.16.309-.346.602-.557.876zM61.082 71.298c.474-.45.066-1.37-.534-1.703-.627-.348-1.404-.408-1.94-.886-.538-.478-.698-1.264-.872-1.978-.22-.9-.533-1.818-1.18-2.47-1.26-1.288-3.535-.561-5.08-.348-.888.122-2.017-.182-2.188-1.08a1.21 1.21 0 0 1 .05-.635c-.217.301-.308.678-.253 1.047.178.899 1.303 1.202 2.19 1.079 1.545-.213 3.82-.94 5.08.35.64.657.96 1.57 1.18 2.47.178.712.329 1.492.871 1.976s1.314.545 1.942.885c.45.248.789.83.734 1.293z" />
      </g>
      <circle
        cx="2.968"
        cy="3.044"
        r="2.947"
        fill="#000"
        fillRule="nonzero"
        opacity=".1"
        transform="translate(54 63)"
      />
      <circle cx="57" cy="66" r="3" fill="#32B496" fillRule="nonzero" />
      <circle cx="57" cy="66" r="2" fill="#333" fillRule="nonzero" />
      <circle cx="57.5" cy="66.5" r="1" fill="#32B496" fillRule="nonzero" />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M57.882 57.563l2.329.454-.017.084-2.328-.454z"
        opacity=".05"
      />
      <path
        fill="#CBDAE3"
        fillRule="nonzero"
        d="M40.56 98.237a1.442 1.442 0 0 1 1.925.673l1.802 3.735a1.44 1.44 0 1 1-2.596 1.25l-1.803-3.734a1.44 1.44 0 0 1 .672-1.924z"
      />
      <path
        fill="#535461"
        fillRule="nonzero"
        d="M40.56 98.237a1.442 1.442 0 0 1 1.925.673l1.802 3.735a1.44 1.44 0 1 1-2.596 1.25l-1.803-3.734a1.44 1.44 0 0 1 .672-1.924z"
      />
      <path
        fill="#6C63FF"
        fillRule="nonzero"
        d="M40.826 98.11a1.484 1.484 0 0 1 1.98.692l1.766 3.66a1.482 1.482 0 0 1-.69 1.978h-.001a1.484 1.484 0 0 1-1.98-.691l-1.767-3.66a1.482 1.482 0 0 1 .692-1.979z"
      />
      <path
        fill="#F2F2F2"
        fillRule="nonzero"
        d="M40.038 99.054l2.019-.973 2.319 4.806-2.019.973z"
      />
      <circle
        cx="43.663"
        cy="103.889"
        r="1"
        fill="#F2F2F2"
        fillRule="nonzero"
        transform="rotate(-25.74 43.663 103.89)"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M59.13 99.285c1.146.01 2.28.173 3.346.482 1.707.508 3.515 0 3.515 0s-5.149-1.093-6.861-.482z"
        opacity=".1"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M120.304 131s1.202 1.443-.554 3.623-3.203 4.019-2.618 5.377c0 0 2.649-4.047 4.805-4.104 2.156-.057.74-2.462-1.633-4.896z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M120.728 131c.088.14.158.292.206.453 1.774 2.272 2.72 4.392 1.015 4.44-1.588.05-3.493 3.148-3.949 3.93.015.06.033.119.054.177 0 0 2.232-4.05 4.05-4.107 1.817-.056.623-2.458-1.376-4.893z"
        opacity=".1"
      />
      <path
        fill="#FFD037"
        fillRule="nonzero"
        d="M122.127 133.26c0 .41-.057.74-.126.74-.07 0-.128-.33-.128-.74 0-.408.071-.214.142-.214s.112-.192.112.215z"
      />
      <path
        fill="#FFD037"
        fillRule="nonzero"
        d="M122.762 133.504c-.39.352-.73.565-.76.475-.03-.09.263-.447.653-.8.39-.351.238-.094.267 0 .03.096.23-.025-.16.325z"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M114.696 131s-1.202 1.443.554 3.623 3.203 4.019 2.618 5.377c0 0-2.649-4.047-4.805-4.104-2.156-.057-.74-2.462 1.633-4.896z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M114.272 131c-.088.14-.158.292-.206.453-1.774 2.272-2.718 4.392-1.013 4.44 1.587.05 3.491 3.148 3.947 3.93-.015.06-.033.119-.054.177 0 0-2.232-4.05-4.05-4.107-1.817-.056-.623-2.458 1.376-4.893z"
        opacity=".1"
      />
      <path
        fill="#FFD037"
        fillRule="nonzero"
        d="M112.872 133.26c0 .41.057.74.128.74.071 0 .128-.33.128-.74 0-.408-.073-.214-.142-.214-.07 0-.114-.192-.114.215z"
      />
      <path
        fill="#FFD037"
        fillRule="nonzero"
        d="M112.237 133.504c.391.352.731.565.761.475.03-.09-.264-.447-.654-.8-.39-.351-.236-.094-.266 0-.03.096-.231-.025.159.325z"
      />
      <path
        fill="#A8A8A8"
        fillRule="nonzero"
        d="M113 139.716s2.96-.099 3.85-.78c.892-.681 4.551-1.494 4.765-.402.215 1.092 4.445 5.436 1.106 5.465-3.338.03-7.76-.559-8.65-1.142-.89-.582-1.071-3.141-1.071-3.141z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M122.782 143.646c-3.339.027-7.757-.52-8.646-1.064-.68-.413-.947-1.898-1.037-2.582H113s.187 2.387 1.076 2.933c.89.546 5.308 1.093 8.646 1.066.963-.009 1.296-.351 1.277-.861-.132.31-.501.503-1.217.508z"
        opacity=".2"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M107.429 142.236c.265-.182.458-.426.553-.701a.593.593 0 0 0-.39-.712c-.37-.115-.738.092-1.033.306-.295.215-.625.447-1.004.403.398-.3.577-.75.472-1.188a.464.464 0 0 0-.131-.242c-.2-.176-.553-.1-.798.04-.758.442-.97 1.297-.973 2.067-.078-.277-.013-.567-.015-.852-.002-.284-.096-.6-.385-.753a1.335 1.335 0 0 0-.586-.114c-.341-.011-.72.016-.953.225-.29.257-.214.688.037.97.25.282.634.46.986.657.283.139.524.33.704.558.022.032.04.065.053.1h2.136c.482-.203.929-.46 1.327-.764z"
      />
      <path
        stroke="#767676"
        strokeWidth="2"
        d="M92.708 141s-1.798-6.579.336-11.42a11.13 11.13 0 0 0 .775-6.52 18.696 18.696 0 0 0-.856-3.06"
      />
      <path
        fill="#6C63FF"
        fillRule="nonzero"
        d="M95 116.55c0 .886-1.5 3.45-1.5 3.45s-1.5-2.57-1.5-3.45c.028-.864.691-1.55 1.5-1.55s1.472.686 1.5 1.55zM96.778 121.199C96.362 121.86 94 123 94 123s.043-2.69.457-3.35c.415-.66 1.27-.849 1.912-.421.64.427.824 1.31.409 1.97zM97.248 128.8c-.675.369-3.248.115-3.248.115s1.34-2.39 2.015-2.757a1.281 1.281 0 0 1 1.367.084c.409.29.643.793.616 1.32-.028.528-.314 1-.75 1.238zM95.401 134.372c-.65.432-3.401.628-3.401.628s1.013-2.309 1.662-2.74c.65-.434 1.567-.312 2.05.272.481.584.346 1.408-.304 1.842l-.007-.002zM90.488 122.751C91.107 123.364 94 124 94 124s-.71-2.923-1.329-3.536c-.4-.405-.982-.56-1.525-.405a1.581 1.581 0 0 0-1.1 1.15 1.612 1.612 0 0 0 .442 1.54v.002zM89.755 129.8c.675.369 3.245.115 3.245.115s-1.34-2.39-2.014-2.757a1.282 1.282 0 0 0-1.368.086c-.41.29-.644.796-.616 1.325.029.529.316 1.002.753 1.24v-.01zM88.598 136.372c.65.432 3.402.628 3.402.628s-1.013-2.309-1.663-2.74a1.602 1.602 0 0 0-1.454-.152c-.48.187-.813.59-.873 1.056-.06.467.161.928.581 1.208h.007z"
      />
      <path
        fill="#32B496"
        fillRule="nonzero"
        d="M95 116.55c0 .886-1.5 3.45-1.5 3.45s-1.5-2.57-1.5-3.45c.028-.864.691-1.55 1.5-1.55s1.472.686 1.5 1.55zM96.778 121.199C96.362 121.86 94 123 94 123s.043-2.69.457-3.35c.415-.66 1.27-.849 1.912-.421.64.427.824 1.31.409 1.97zM97.248 128.8c-.675.369-3.248.115-3.248.115s1.34-2.39 2.015-2.757a1.281 1.281 0 0 1 1.367.084c.409.29.643.793.616 1.32-.028.528-.314 1-.75 1.238zM95.401 134.372c-.65.432-3.401.628-3.401.628s1.013-2.309 1.662-2.74c.65-.434 1.567-.312 2.05.272.481.584.346 1.408-.304 1.842l-.007-.002zM90.488 122.751C91.107 123.364 94 124 94 124s-.71-2.923-1.329-3.536c-.4-.405-.982-.56-1.525-.405a1.581 1.581 0 0 0-1.1 1.15 1.612 1.612 0 0 0 .442 1.54v.002zM89.755 129.8c.675.369 3.245.115 3.245.115s-1.34-2.39-2.014-2.757a1.282 1.282 0 0 0-1.368.086c-.41.29-.644.796-.616 1.325.029.529.316 1.002.753 1.24v-.01zM88.598 136.372c.65.432 3.402.628 3.402.628s-1.013-2.309-1.663-2.74a1.602 1.602 0 0 0-1.454-.152c-.48.187-.813.59-.873 1.056-.06.467.161.928.581 1.208h.007z"
      />
      <path
        fill="#A8A8A8"
        fillRule="nonzero"
        d="M89 140.474s2.292-.504 2.904-1.175c.612-.671 3.363-1.847 3.668-1.009.305.838 4.128 3.695 1.525 4.2-2.602.504-6.113.67-6.877.335-.764-.335-1.22-2.35-1.22-2.35z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M97.101 142.357c-2.599.397-6.114.528-6.878.264-.583-.2-.986-1.167-1.147-1.621l-.076.015s.46 1.584 1.223 1.848c.764.264 4.28.131 6.878-.264.749-.115.964-.383.883-.724-.065.227-.32.397-.883.482z"
        opacity=".2"
      />
    </g>
  </svg>
);

OtherCityImage.propTypes = {
  className: PropTypes.string
};

export default OtherCityImage;
